import MenuButton from "../menuButton";
import LogoButton from "./logoButton";

const Header = ({ onClick }) => {
  return (
    <div className="absolute top-0 left-0 z-[2] w-full h-[70px] md:h-[100px] px-smallMobile md:px-mediumDesktop bg-dune">
      <nav className="w-full h-full max-w-container mx-auto flex justify-between items-center">
        <MenuButton onClick={onClick} textColor="olive" />
        <LogoButton />
        <div className="flex items-center gap-6">
          <a
            href="https://open.mahimabali.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:inline custom-underline cursor-pointer uppercase text-headerMobile md:text-buttonHeaderDesktop font-chivoMono text-olive"
          >
            Mahima Open 2026
          </a>
          <MenuButton name="Book & Join" link="/book-join" textColor="olive" />
        </div>
      </nav>
    </div>
  );
};

export default Header;
